// @flow

import React from 'react'
import type { Image as ImageType } from 'types/'
import { markdown } from 'markdown'
import Container from './Container'
import Appear from './Appear'
import SectionTitle from './SectionTitle'
import Cta from './Cta'

type Props = {
  image: ImageType,
  title: string,
  text: string,
  ctaURL: string,
  ctaText: string,
  pageTitle: string,
}

const Inscriptions = ({ image, title, text, ctaURL, ctaText, pageTitle }: Props) => {
  return (
    <div className="bg-light-gray">
      <SectionTitle title={pageTitle} />
      <Appear>
        <Container className="pb-16">
          <div key="content" className="flex-1 pb-12 shadow-xl md:pb-16 bg-pink">
            <div className="h-4 mb-6 border-b-4 border-dashed border-light-gray bg-pink" />
            <div
              key="image-container"
              className="flex flex-col-reverse items-center px-5 pb-6 text-xl font-black md:px-8 justify-cente md:flex-row md:items-center md:justify-start"
            >
              <img src={`${image.dir}${image.name.normal}.${image.extension}`} className="w-auto h-20 mt-6 md:w-12 md:h-auto md:mt-0 md:mr-6" alt={title} />
              <h3 className="max-w-md leading-tight text-center md:text-left">{title}</h3> 
          </div>
          {text && 
            <div
              key="text-container"
              className="max-w-lg px-5 text-base text-center md:px-8 md:text-left"
              dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }}
            />
          }
          <div className="flex items-stretch justify-center px-4 pt-8 md:pt-3 md:px-8 md:block">
            <Cta ctaURL={ctaURL} ctaText={ctaText} color="901C7F" />
          </div>
        </div>
        </Container>
      </Appear>
    </div>
  )
}

export default Inscriptions
